import React from 'react';
import { clsx } from 'clsx';
import { formatRigaTime } from '@/utils/report-format';

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  sent: 'Sent',
};

const STATUS_COLORS: Record<string, string> = {
  draft: 'bg-yellow-100 text-yellow-800',
  sent: 'bg-green-100 text-green-800',
};

interface ReportStatusBarProps {
  counterpartyName: string;
  status: string;
  updatedAt: string | null;
  sentByEmail: string | null;
  sentAt: string | null;
  itemCount: number;
}

export const ReportStatusBar: React.FC<ReportStatusBarProps> = ({
  counterpartyName,
  status,
  updatedAt,
  sentByEmail,
  sentAt,
  itemCount,
}) => {
  const formattedModified = updatedAt
    ? new Date(updatedAt).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="flex items-center gap-4 text-sm">
      <span className="font-bold text-gray-900">{counterpartyName}</span>
      <span
        className={clsx(
          'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
          STATUS_COLORS[status] ?? 'bg-gray-100 text-gray-700'
        )}
      >
        {STATUS_LABELS[status] ?? status}
      </span>
      {status === 'sent' ? (
        <span className="text-gray-700">
          {sentAt
            ? sentByEmail
              ? `Sent by ${sentByEmail} at ${formatRigaTime(sentAt)}`
              : `Auto-sent at ${formatRigaTime(sentAt)}`
            : updatedAt
              ? `Sent at ${formatRigaTime(updatedAt)}`
              : null}
        </span>
      ) : (
        formattedModified && (
          <span className="text-gray-700">Modified: {formattedModified}</span>
        )
      )}
      <span className="text-xs text-gray-400">{itemCount} items</span>
    </div>
  );
};
